import { createAsyncThunk } from "@reduxjs/toolkit";
import { send } from "../../app/appSlice";
import { AppThunkApi } from "../../app/store";
import * as S from "../../services/auth";
import { LoginParams } from "../../services/auth";

export const login = createAsyncThunk<any, LoginParams, AppThunkApi>(
  "auth/loginStatus",
  async (params, api) => {
    return send(S.login(params), api);
  }
);

export const ssoLogin = createAsyncThunk<any, string, AppThunkApi>(
  "auth/ssoLoginStatus",
  async (params, api) => {
    return send(S.ssoLogin(params), api, true);
  }
);
